import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { VegWizardDataService } from 'src/app/veg-wizard/services/veg-wizard-data.service';
import { VegWizardStateMachineService } from 'src/app/veg-wizard/services/veg-wizard-state-machine.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivateAcknowledgeNotificationGuard implements CanActivate {
  constructor(public vwds: VegWizardDataService,
    public stateMachine: VegWizardStateMachineService,
    public router: Router) { }

  canActivate() {

    const dataState = this.vwds.getWizardDataState();

    const result = this.stateMachine.getAcknowledgementRouteProperties(dataState);

    if (!result.isEnabled) {
      console.warn('CanActivateAcknowledgeNotificationGuard - Required data does not exist!');
      this.router.navigate(this.stateMachine.determineRouteNavigationForGuard());
      return false;
    }

    return result.isEnabled;
  }

}
